import { CurationItem } from "../../types";
import { callCurationProxy } from "../backend/backendClient";
import { listLogger } from "./helpers";

/**
 * Gets a list by ID
 * @param listId
 * @returns {Promise<CurationItem | null>}
 */
export const getListById = async (listId: string): Promise<CurationItem | null> => {
    if (!listId) {
        throw new Error("getListById requires a listId.");
    }

    const response = await callCurationProxy({
        path: `/list/${listId}`,
        method: "GET",
    });

    const responseText = await response.text();

    if (responseText.trim().toLowerCase().startsWith("<!doctype html")) {
        throw new Error(
            "Authentication Failed: The API returned a login page. Please verify your authentication cookies.",
        );
    }

    if (!response.ok) {
        throw new Error(`API Error: ${response.status} - ${responseText}`);
    }

    try {
        const data = JSON.parse(responseText) as Record<string, { result?: CurationItem }>;
        const listData = data[listId];
        return listData?.result ?? null;
    } catch (error) {
        listLogger.error("Failed to parse API response as JSON:", responseText);
        throw new Error("The API returned a response that was not valid JSON.");
    }
};
